import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'particle-jurisdiction-cell-viewer',
  templateUrl: './jurisdiction-cell-viewer.component.html',
  styleUrls: ['./jurisdiction-cell-viewer.component.scss']
})
export class JurisdictionCellViewerComponent implements OnInit, CellComponent {

  fieldDefinition: FieldDefinition;
  item: any;

  @Output() valueChanged: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
  }



}
